import { IonButton, IonIcon } from '@ionic/react';
import React from 'react';

import { ButtonContainer, Spacer } from '@/components/common';
import Selection from '@/components/selection/Selection';
import { useClinicGroup } from '@/contexts/ClinicGroupContext';
import { Clinic } from '@/data/Clinics';
import { useToast } from '@/hooks';
import { arrowForwardCircleOutline, locationOutline } from 'ionicons/icons';

import './SelectBranch.css';

const SelectBranch: React.FC = () => {
  const displayToast = useToast();
  const {
    branches,
    clinicGroup,
    selectedBranch,
    setSelectedBranch,
    onSelectBranch
  } = useClinicGroup();

  if (!clinicGroup) return null;

  const copy = {
    subHeader: 'SELECT A BRANCH',
    header: clinicGroup.name,
    message: 'Please select your preferred branch.',
    buttonText: 'Next'
  };

  const getLabel = (clinic: Clinic) => {
    return clinic.name;
  };

  const isSelected = (clinic: Clinic) => clinic.id === selectedBranch?.id;

  const onNext = () => {
    if (selectedBranch) {
      onSelectBranch(selectedBranch.id!);
    } else {
      displayToast({
        message: `Please select a branch to proceed.`,
        duration: 2400,
        position: 'bottom',
        positionAnchor: 'nextButton'
      });
    }
  };

  return (
    <div className="select-branch">
      <IonIcon
        color="primary"
        icon={locationOutline}
        className="select-branch__icon"
      />
      <h4 className="select-branch__sub-header">{copy.subHeader}</h4>
      <h1 className="select-branch__header">{copy.header}</h1>
      <p className="select-branch__message">{copy.message}</p>
      <Spacer top={24} bottom={102}>
        <Selection
          options={branches}
          getLabel={getLabel}
          onClick={setSelectedBranch}
          isSelected={isSelected}
        />
      </Spacer>
      <ButtonContainer>
        <IonButton
          className="select-branch__next-button"
          onClick={onNext}
          expand="block"
          fill="solid"
          size="default"
          color="primary"
          strong
        >
          <IonIcon slot="start" icon={arrowForwardCircleOutline}></IonIcon>
          {copy.buttonText}
        </IonButton>
      </ButtonContainer>
    </div>
  );
};

export default SelectBranch;
